import { render, staticRenderFns } from "./ViewRegionView.vue?vue&type=template&id=44322956"
import script from "./ViewRegionView.vue?vue&type=script&lang=js"
export * from "./ViewRegionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports